import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  table: {
    borderCollapse: 'collapse',
    width: '100%',
    fontSize: '0.875rem',
  },

  th: {
    textAlign: 'left',
    padding: '0.5rem',
    borderBottom: '1px solid #ddd',
  },

  td: {
    padding: '0.5rem',
  },
})

export default useStyles
